import {
    FilterContainer,
    FilterDetailsContainer,
    ViewContainer,
    ExtraContainer,
    FilterStringWithPipe,
    Counter,
    CounterNumber,
    ClearFilterDesktop,
    FilterWrapperContainer,
} from 'src/pages/home/component/actionsPanel/filterResultsPanel/FilterResultsPanel.styled';
import React, { useState, useRef } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setFilterPopoverOpen } from 'src/pages/home/redux/actions';
import { dynamicPluralization, isMobileDevice } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const FilterResultsPanel = (props) => {
    const { clearFilterHandler, resetHandler, setClearFilterClicked } = props;
    const dispatch = useDispatch();
    const [, setFiltersCount] = useState(0);
    const [selectedViewFilterDisplayValue, setSelectedViewFilterDisplayValue] =
        useState('');
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth,
    });
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );
    const { t } = useTranslation();
    useEffectWithErrorLogging(() => {
        // if (window.innerWidth > sizes.mobileDevice) {
        setFilterOverflow(
            !(ref.current.scrollWidth <= ref.current.clientWidth)
        );
        // }

        const handleResize = () => {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });

    const appliedFilters = useSelector(
        (state) => state.appliedFiltersReducer,
        shallowEqual
    );
    const [filterOverflow, setFilterOverflow] = useState(false);
    const selectedViewFilter = useSelector(
        (state) => state.filterReducer.userFilters.filterParam
    );

    const defaultCalendarViewId = useSelector(
        (state) => state.appliedFiltersReducer.defaultCalendarViewId
    );
    const displayFilters = useSelector(
        (state) => state.appliedFiltersReducer.displayFilters,
        shallowEqual
    );

    useEffectWithErrorLogging(() => { 
        setFiltersCount(displayFilters.length);
    }, [displayFilters]);

    useEffectWithErrorLogging(() => {
        let basicFilters = appliedFilters.basicFilters || [];
        let salesHierarchies = appliedFilters.salesHierarchies || [];
        if (selectedViewFilter) {
            setSelectedViewFilterDisplayValue(
                [...basicFilters, ...salesHierarchies].find(
                    (item) => item.id === selectedViewFilter
                )?.name
            );
        } else {
            setSelectedViewFilterDisplayValue(
                [...basicFilters, ...salesHierarchies].find(
                    (item) => item.selected
                )?.name
            );
        }
    }, [selectedViewFilter]);

    const ref = useRef('');

    useEffectWithErrorLogging(() => {
        // if (window.innerWidth > sizes.mobileDevice) {
        setFilterOverflow(
            !(ref.current.scrollWidth <= ref.current.clientWidth)
        );
        // }
    }, [dimensions]);

    let filterString = '';
    const maxVisible = isMobileDevice() ? 1 : 3;
    const visibleFilters = Array.isArray(displayFilters)
        ? displayFilters.slice(0, maxVisible)
        : [];

    visibleFilters?.map((filter, index) => {
        if (index < visibleFilters.length - 1) {
            filterString += `${filter} | `;
        } else {
            filterString += `${filter} `;
        }
    });

    // Clear filter handler function
    const handleClearClick = () => {
        if (setClearFilterClicked) {
            setClearFilterClicked(true);
        }
        if (clearFilterHandler) {
            clearFilterHandler();
        }
        if (resetHandler) {
            resetHandler();
        }
    };

    const handleClearKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClearClick();
        }
    };
    return (
        <FilterWrapperContainer>
            <FilterContainer {...props} style={{ flex: 1 }}>
                {selectedViewFilter === 'all' ||
                defaultCalendarViewId === 'all' ? (
                    selectedViewFilter && selectedViewFilter !== 'all' ? (
                        <ViewContainer
                            flexBasisStyle={props.flexBasisStyle}
                            wordBreak={isLanguageChanged && 'keep-all'}
                        >
                            {t('calendar.filterResultsPanel.viewLabel')}:{' '}
                            <span> {selectedViewFilterDisplayValue}</span>
                            {!props.orderCondition && (
                                <>
                                    {' | '}
                                    <span>
                                        {t(
                                            'calendar.filterResultsPanel.unassigned'
                                        )}
                                    </span>
                                </>
                            )}
                        </ViewContainer>
                    ) : (
                        ''
                    )
                ) : (
                    selectedViewFilterDisplayValue && (
                        <ViewContainer
                            {...props}
                            wordBreak={isLanguageChanged && 'keep-all'}
                        >
                            {t('calendar.filterResultsPanel.viewLabel')}:{' '}
                            <span> {selectedViewFilterDisplayValue}</span>
                            {!props.orderCondition && (
                                <>
                                    {' | '}
                                    <span>
                                        {t(
                                            'calendar.filterResultsPanel.unassigned'
                                        )}
                                    </span>
                                </>
                            )}
                        </ViewContainer>
                    )
                )}
                <FilterDetailsContainer
                    // marginTop={displayFilters?.length > 0 ? '15px' : '0'}
                    maxWidth={
                        !props.orderCondition
                            ? props.calendarView == 'Month'
                                ? selectedViewFilterDisplayValue != 'All'
                                    ? '39%'
                                    : '68%'
                                : props.calendarView == 'Week'
                                ? selectedViewFilterDisplayValue != 'All'
                                    ? '60%'
                                    : '79%'
                                : props.calendarView == 'List'
                                ? selectedViewFilterDisplayValue != 'All'
                                    ? '60%'
                                    : '79%'
                                : ''
                            : ''
                    }
                    ipadWidth={
                        !props.orderCondition
                            ? selectedViewFilterDisplayValue != 'All'
                                ? '45%'
                                : '71%'
                            : '100%'
                    }
                    ipadLandscapeWidth={
                        !props.orderCondition
                            ? props.calendarView == 'Month'
                                ? selectedViewFilterDisplayValue != 'All'
                                    ? '29%'
                                    : '63%'
                                : props.calendarView == 'Week'
                                ? selectedViewFilterDisplayValue != 'All'
                                    ? '54%'
                                    : '75%'
                                : props.calendarView == 'List'
                                ? selectedViewFilterDisplayValue != 'All'
                                    ? '54%'
                                    : '75%'
                                : ''
                            : ''
                    }
                >
                    <>
                        <>
                            {displayFilters.length
                                ? `${dynamicPluralization(
                                      t(
                                          'calendar.filterResultsPanel.filterLabel'
                                      ),
                                      t('common.filtersLabel'),
                                      displayFilters.length
                                  )}  (${displayFilters.length}): `
                                : ''}
                        </>
                        <FilterStringWithPipe ref={ref}>
                            {filterString}
                        </FilterStringWithPipe>
                    </>

                    {displayFilters.length > maxVisible && (
                        <ExtraContainer
                            id="home-filterresultspanel-more-filters-container"
                            onClick={() => dispatch(setFilterPopoverOpen(true))}
                        >
                            <Counter>
                                <CounterNumber>
                                    {`+ ${displayFilters.length - maxVisible}`}
                                </CounterNumber>
                            </Counter>
                        </ExtraContainer>
                    )}
                </FilterDetailsContainer>
                {isMobileDevice() &&
                (displayFilters.length > 0 ||
                    selectedViewFilterDisplayValue) ? (
                    <ClearFilterDesktop
                        role="button"
                        tabIndex={0}
                        onClick={handleClearClick}
                        onKeyDown={handleClearKeyDown}
                    >
                        {t('physicians.filterResults.clearFilters')}
                    </ClearFilterDesktop>
                ) : null}
            </FilterContainer>
            {!isMobileDevice() &&
            (displayFilters.length > 0 || selectedViewFilterDisplayValue) ? (
                <ClearFilterDesktop
                    role="button"
                    tabIndex={0}
                    onClick={handleClearClick}
                    onKeyDown={handleClearKeyDown}
                >
                    {t('physicians.filterResults.clearFilters')}
                </ClearFilterDesktop>
            ) : null}
        </FilterWrapperContainer>
    );
};

export default FilterResultsPanel;
